import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const RebelsTheme = definePreset(Aura, {
  semantic: {
    ...Aura.semantic,
    primary: {
      50: '#f7f4f4',
      100: '#dac8c9',
      200: '#bd9c9e',
      300: '#a07074',
      400: '#834549',
      500: '#66191e',
      600: '#57151a',
      700: '#471215',
      800: '#380e11',
      900: '#290a0c',
      950: '#1a0608'
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}'
        },
          formField: {
              background: '#141820',
              disabledBackground: '#1a1e2a',
              filledBackground: '#141820',
              filledHoverBackground: '#141820',
              filledFocusBackground: '#141820',
              borderColor: '#3a404d',
              hoverBorderColor: '#5f6778',
              focusBorderColor: '#b35a5f',
              invalidBorderColor: '#fc8181',
              color: '#f3f5f9',
              disabledColor: '#5c6880',
              placeholderColor: '#4a5162',
              floatLabelColor: '#4a5162',
              floatLabelFocusColor: '#b35a5f',
              floatLabelActiveColor: '#6b7488',
              floatLabelInvalidColor: '#fc8181',
              iconColor: '#6b7488',
              shadow: 'none',
        }
      },
      dark: {
        primary: {
          color: '{primary.400}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}'
        },
          formField: {
              background: '#141820',
              disabledBackground: '#1a1e2a',
              filledBackground: '#141820',
              filledHoverBackground: '#141820',
              filledFocusBackground: '#141820',
              borderColor: '#3a404d',
              hoverBorderColor: '#5f6778',
              focusBorderColor: '#b35a5f',
              invalidBorderColor: '#fc8181',
              color: '#f3f5f9',
              disabledColor: '#5c6880',
              placeholderColor: '#4a5162',
              floatLabelColor: '#4a5162',
              floatLabelFocusColor: '#b35a5f',
              floatLabelActiveColor: '#6b7488',
              floatLabelInvalidColor: '#fc8181',
              iconColor: '#6b7488',
              shadow: 'none',
        }
      }
    }
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            }
          }
        },
        dark: {
          root: {
            primary: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            }
          }
        }
      }
    }
  }
});

export default RebelsTheme;
